import React from 'react';
import { func, string, bool, number, arrayOf } from 'prop-types';
import { Flex } from 'grid-styled';
import MenuItem from 'material-ui/MenuItem';

import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';

import MetricSelector from './MetricSelector';
import TimespanSelector from './TimespanSelector';
import CrimeTypeSelector from './CrimeTypeSelector';
import DataSettingsDialog from './DataSettingsDialog';
import CompareSelector from './CompareSelector';

import { Timespan, Compare } from '../constants';

import {
  Metric as IMetric,
  Timespan as ITimespan,
  Compare as ICompare,
} from '../models';

const SettingsBar = ({
  crimeType,
  metric,
  compare,
  timespan,

  availableCompare,

  setCrimeType,
  setMetric,
  setCompare,
  setTimespan,

  isDataSettingsDialogOpened,
  openDataSettingsDialog,
  censusView,
  theme,
  location,
  match: { params },
}) => (
  <Flex alignItems="center" className="settingsBar">
    <CrimeTypeSelector
      labelColor="rgba(255, 255, 255, 0.93)"
      value={parseInt(crimeType, 10)}
      onChange={setCrimeType}
      selectedMenuItemStyle={{ color: theme.colors.gold800 }}
      withTitle
      theme={theme}
    />
    <MetricSelector
      labelColor="rgba(255, 255, 255, 0.93)"
      value={metric}
      onChange={setMetric}
      selectedMenuItemStyle={{ color: theme.colors.gold800 }}
      withTitle
      theme={theme}
    />
    <TimespanSelector
      labelColor="rgba(255, 255, 255, 0.93)"
      value={timespan}
      onChange={setTimespan}
      selectedMenuItemStyle={{ color: theme.colors.gold800 }}
      theme={theme}
    >
      <MenuItem
        value={Timespan.CUSTOM}
        primaryText="Custom…"
        theme={theme}
        selectedMenuItemStyle={{ color: theme.colors.gold800 }}
        onClick={openDataSettingsDialog}
      />
    </TimespanSelector>
    {!censusView && (
      <CompareSelector
        labelColor="rgba(255, 255, 255, 0.93)"
        theme={theme}
        value={compare}
        selectedMenuItemStyle={{ color: theme.colors.gold800 }}
        availableCompare={availableCompare}
        onChange={setCompare}
      >
        <MenuItem
          value={Compare.CUSTOM}
          disabled={false}
          primaryText="Custom…"
          onClick={openDataSettingsDialog}
          theme={theme}
        />
      </CompareSelector>
    )}
    <DataSettingsDialog />
  </Flex>
);

SettingsBar.propTypes = {
  metric: IMetric.isRequired,
  timespan: ITimespan.isRequired,
  compare: ICompare.isRequired,
  crimeType: number.isRequired,

  availableCompare: arrayOf(string).isRequired,

  setMetric: func.isRequired,
  setCompare: func.isRequired,
  setTimespan: func.isRequired,
  setCrimeType: func.isRequired,

  isDataSettingsDialogOpened: bool.isRequired,
  openDataSettingsDialog: func.isRequired,
};

export default withTheme(withRouter(SettingsBar));



// WEBPACK FOOTER //
// ./src/components/SettingsBar.jsx